// @flow
import React, { Component } from 'react';
import styled from 'styled-components';
import _ from 'lodash';

import TeamUserAvatar from '../Team/TeamUserAvatar';

import { ButtonSecondaryLink, ButtonSecondary } from '../../components/ButtonSecondary';

import colors from '../../assets/css/colors';
import { above, below } from '../../assets/css/media';
import getDisplayRank from '../../helpers/getDisplayRank';
import { getTeamScoreFromLadder } from '../../helpers/team';
import PlateWinnerTrophyImg from '../../assets/images/trophy.svg';
import WinnerTrophyImg from '../../assets/images/trophy-colored.svg';

const TeamUserAvatarWrapper = styled.div`
	display: flex;
    align-items: center;
`;

const TeamUserAvatarStyled = styled(TeamUserAvatar)`
	width: ${({ compact }) => compact ? '30px' : '60px' };

	${below.phone`
		margin-bottom: 10px;
	`}
`;

const FixtureWrapper = styled.div`
	position: relative;
	background: #ffffff;
	padding: ${({ compact }) => compact ? '5px 10px' : '10px' };
	min-height: ${({ compact }) => compact ? '60px' : '120px' };

	display: flex;
	justify-content: space-between;
	align-items: center;

	${({ shadow }) => shadow && `box-shadow: ${colors.box_shadow}`}

	${({ show_final_ladder_rank, compact }) => show_final_ladder_rank && `
		padding: ${compact ? '5px 25px' : '10px 25px'};
	`}
`;

const Score = styled.div`
	min-width: 45px;
	font-size: 22px;
	line-height: 1.27;
	font-weight: bold;
	letter-spacing: -0.5;
	text-align: center;
	
	${({ live }) => live ? 
		'background: #7ed320;' +
		'color: #ffffff;' +
		'padding: 4px 6px;' +
		'font-size: 20px;' +
		'border-radius: 20px;' 
		: `color: ${colors.nrlDarkGreen}`}

	${above.phone`
		font-size: ${({ compact }) => compact ? '22px' : '26px' };
		line-height: 1.2;
	`}
`;

const ProjectedScore = styled.div`
	font-size: 12px;
	line-height: 1;
	font-weight: bold;
	color: ${colors.coachPurple};
`;

const ProjectedScoreContainer = styled.div`
	display: inline-block;
	border: 1px solid ${colors.coachPurple};
	border-radius: 10px;
	padding: 3px 10px;
	margin: ${({ right }) => right ? '5px 0 0 0;' : '5px 0 0 0px;'};
	${({ right }) => right && 'float: right;'}
`;

const ScoreWrapper = styled.div`
	flex: 0 0 50%;
	margin-bottom: 5px;

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	${above.phone`
		flex: 1 2 20%;
	`}

	${above.tablet`
		margin: 0;
	`}
`;

const MatchUpButton = styled(ButtonSecondaryLink)`
	width: 100%;
	cursor: default;
	color: ${colors.nrlDarkGreen};
	border: 1px solid currentColor;
	cursor: pointer;

	&:hover {
		color: ${colors.nrlDarkGreenHover};
	}

	${above.tablet`
		width: auto;
	`}
`;

const VersusButton = styled(ButtonSecondary)`
	border: none;
	color: ${colors.grey};
	background: transparent;
	pointer-events: none;
`;


const AboveTabletCenterWrapper = styled.div`
	display: flex;
	flex: 0 1 42%;
	align-items: center;

	${below.tablet`
		display: none;
	`};
`;

const BelowTabletCenterWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;

	${above.tablet`
		display: none;
	`};
`;

const AbovePhone = styled.div`
	${below.phone`
		display: none;
	`};
`;

const BelowPhone = styled.div`
	${above.phone`
		display: none;
	`};
`;

const TeamName = styled.div`
	font-size: 16px;
	line-height: 1;
	font-weight: bold;
	color: ${colors.nrlDarkGreen};
	margin-bottom: 0.43em;

	text-overflow: ellipsis;
	overflow: hidden;
	max-width: 60px;

	${above.phone`
		max-width: 110px;
	`}

	${above.tablet`
		max-width: 130px;
	`}

	${above.desktop`
		max-width: 150px;
	`}

	${below.phone`
		text-align: center;
		font-size: 12px;
	`}
`;

const UserName = styled.div`
	font-size: 14px;
	line-height: 1;
	color: ${colors.darkGrey};

	${below.phone`
		display: none;
	`}
`;

const LadderLabel = styled.div`
	font-size: 14px;
	line-height: 1.28;
	color: ${colors.darkGrey};

	strong {
		font-weight: bold;
	}

	${below.phone`
		display: none;
	`}
`;

const TeamDetailsWrapper = styled.div`
	display: flex;
	justify-content: ${({ right }) => right ? 'flex-end' : 'flex-start'}
	flex-direction: column;
	flex: 1 2 100%;

	${below.phone`
		justify-content: center;
	`}

	${({ right }) => right && `

		${// $FlowFixMe
	TeamName} {
			text-align: right;
		}
	`}
`;

const SideWrapperStyles = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	flex: 0 1 25%;

	${below.phone`
		align-self: flex-start;
		flex: 0 1 40%;
	`}

	${above.phone`
		flex-direction: row;
	`}

	${above.tablet`
		flex: 0 1 25%;
	`}
`;

const HomeSideWrapper = styled(SideWrapperStyles)`
	margin-right: 2%;

	${TeamUserAvatarStyled} {
		margin-right: 10px;
	}

	${below.phone`
		${TeamUserAvatarStyled} {
			margin-right: 5px;
		}
	`}
`;

const AwaySideWrapper = styled(SideWrapperStyles)`
	flex-direction: column-reverse;
	justify-content: flex-end;
	margin-left: 2%;

	${above.phone`
		flex-direction: row;
	`}

	${TeamUserAvatarStyled} {
		margin-left: 10px;
	}

	${TeamDetailsWrapper} {
		align-items: flex-end;
	}

	${below.phone`
		${TeamUserAvatarStyled} {
			margin-left: 5px;
		}
	`}
`;

const FinalLadderPosition = styled.div`
	display: flex;
	background: ${colors.title};
	color: #fff;
	font-size: 11px;
	height: 100%;
	width: 20px;
	position: absolute;
	align-items: center;
	justify-content: center;

	${({ right }) => right ? `right: 0` : `left: 0`};
`;

const TrophyWrapper = styled.div`
	margin: 0 2px;
`;

type TLeague = {
	id: number,
	bye_rounds: number,
	status: string
}

type TTeam = {
	id: number,
	name: string,
	firstname: string,
	lastname: string,
	points: number,
	projected_points: number,
	rank: number,
	lineup: {
		"1": Array<number>,
		"2": Array<number>,
		"3": Array<number>,
		"4": Array<number>,
		"5": Array<number>,
		"6": Array<number>,
		bench?: Array<number>,
		captain?: number,
		vice_captain?: number,
		emergency?: Object
	},
	avatar_version: number,
	user_id: number
}

type TFixture = {
	home: TTeam,
	away: TTeam
}

type Props = {
	league: TLeague,
	fixture: TFixture,
	round: Object,
	shadow?: boolean,
	compact?: boolean,
	show_final_ladder_rank?: boolean,
	className?: string,
	has_assistant_coach: boolean,
	versus?: boolean,
	players: Object,
	show_trophy?: boolean
}

class Fixture extends Component<Props> {
	get is_scheduled() {
		const { round } = this.props;
		return round.status === 'scheduled';
	}

	get is_live() {
		const { round } = this.props;
		return round.status === 'active';
	}

	get show_projected_score() {
		const { has_assistant_coach } = this.props;
		return (this.is_scheduled || this.is_live) && has_assistant_coach;
	}

	get fixture_winner_id() {
		const { league } = this.props;
		return _.get(league, 'fixture_winner');
	}

	get fixture_plate_winner_id() {
		const { league } = this.props;
		return _.get(league, 'fixture_plate_winner');
	}

	renderHomeScoreSection = () => {
		const { fixture: { home }, compact, round, players } = this.props;

		if(!round) {
			return null;
		}

		const live_points = getTeamScoreFromLadder({
			round,
			team: home,
			players_by_id: players,
			is_active_match: this.is_live,
			is_classic: false
		});

		const points = this.is_live? live_points: home.points;

		return (
			<ScoreWrapper>
				<Score live={this.is_live} compact={compact}>
					{points || '--'}
				</Score>
				{this.show_projected_score && (
					<ProjectedScoreContainer>
						<ProjectedScore>{home.projected_points}</ProjectedScore>
					</ProjectedScoreContainer>
				)}
			</ScoreWrapper>
		);
	}

	renderAwayScoreSection = () => {
		const { fixture: { away }, compact, round, players } = this.props;

		if(!round) {
			return null;
		}

		const live_points = getTeamScoreFromLadder({
			round,
			team: away,
			players_by_id: players,
			is_active_match: this.is_live,
			is_classic: false
		});

		const points = this.is_live? live_points: away.points;

		return (
			<ScoreWrapper right>
				<Score compact={compact} live={this.is_live}>{points || '--'}</Score>
				{this.show_projected_score && (
					<ProjectedScoreContainer right>
						<ProjectedScore>{away.projected_points}</ProjectedScore>
					</ProjectedScoreContainer>
				)}
			</ScoreWrapper>
		);
	}

	renderMatchupButton = () => {
		const { league, round, fixture: { away, home }, versus } = this.props;

		if(versus) {
			return (
				<VersusButton>
					versus
				</VersusButton>
			);
		}

		return (
			<MatchUpButton
				to={`/league/${league.id}/matchup/${home.id}/${away.id}/${round.id}`}
			>
				GO TO MATCH UP
			</MatchUpButton>
		);
	}

	renderTeamUserAvatar = (team: TTeam, align_right?: boolean) => {
		const { compact } = this.props;

		const renderTrophy = () => (
			<React.Fragment>
				<BelowPhone>
					{this.renderTrophySection(team)}
				</BelowPhone>
			</React.Fragment>
		);

		return (
			<TeamUserAvatarWrapper>
				{align_right ? renderTrophy() : null}
				<TeamUserAvatarStyled
					compact={compact}
					user_id={team.user_id}
					avatar_version={team.avatar_version}
				/>
				{!align_right ? renderTrophy() : null}
			</TeamUserAvatarWrapper>
		);
	}

	renderTeamDetails = (team: TTeam, align_right?: boolean) => {
		const { compact } = this.props;

		return (
			<TeamDetailsWrapper right={align_right}>
				<TeamName>{team.name}</TeamName>
				<UserName>{_.get(team, 'firstname[0]', '')}. {team.lastname}</UserName>
				{!compact && (
					<LadderLabel>
						Ladder Position <strong>{getDisplayRank(team.rank)}</strong>
					</LadderLabel>
				)}
			</TeamDetailsWrapper>
		);
	}

	renderTrophySection = (team: TTeam) => {
		const { show_trophy } = this.props;
		const is_plate_winner = _.get(team, 'id') === this.fixture_plate_winner_id;
		const is_winner = _.get(team, 'id') === this.fixture_winner_id;

		if (show_trophy && is_winner) {
			return <TrophyWrapper><img src={WinnerTrophyImg} alt="Winner Trophy" /></TrophyWrapper>;
		}

		if (show_trophy && is_plate_winner) {
			return <TrophyWrapper>
				<img src={PlateWinnerTrophyImg} alt="Plate Winner Trophy" />
			</TrophyWrapper>;
		}

		return null;
	}

	render() {
		const {
			fixture: { home, away },
			shadow,
			compact,
			show_final_ladder_rank,
			className
		} = this.props;

		return (
			<FixtureWrapper
				className={className}
				shadow={shadow}
				compact={compact}
				show_final_ladder_rank={show_final_ladder_rank}
			>
				{show_final_ladder_rank
					? <FinalLadderPosition>{home.rank}</FinalLadderPosition>
					: null
				}

				<HomeSideWrapper>
					{this.renderTeamUserAvatar(home)}
					{this.renderTeamDetails(home)}
					<AbovePhone>
						{this.renderTrophySection(home)}
					</AbovePhone>
				</HomeSideWrapper>

				<BelowTabletCenterWrapper>
					{this.renderHomeScoreSection()}
					{this.renderAwayScoreSection()}
					{this.renderMatchupButton()}
				</BelowTabletCenterWrapper>

				<AboveTabletCenterWrapper>
					{this.renderHomeScoreSection()}
					{this.renderMatchupButton()}
					{this.renderAwayScoreSection()}
				</AboveTabletCenterWrapper>

				<AwaySideWrapper>
					<AbovePhone>
						{this.renderTrophySection(away)}
					</AbovePhone>
					{this.renderTeamDetails(away, true)}
					{this.renderTeamUserAvatar(away)}
				</AwaySideWrapper>

				{show_final_ladder_rank
					? <FinalLadderPosition right>{away.rank}</FinalLadderPosition>
					: null
				}
			</FixtureWrapper>
		);
	}
}

export default Fixture;


// WEBPACK FOOTER //
// ./src/components/Fixture/index.js